import { createSlice } from '@reduxjs/toolkit';
import { approveSuggestedFaq, rejectSuggestedFaq } from '@/modules/SuggestedFaqDetails/feature';
import { showApiErrors } from '@/utils';
import { updateConversationSuggestions } from '../helpers';
import { getConversationById, getConversationChannelTheme } from './actionCreators';
import { ConversationDetailsState, SLICE_NAME, initialState } from './models';

export const conversationDetailsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetConversationDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConversationById.pending, (state: ConversationDetailsState, action) => {
        state.isLoading = true;
        state.error = null;
        if (state.item?.conversationId !== action.meta.arg.id) {
          state.item = null;
        }
      })
      .addCase(getConversationById.fulfilled, (state: ConversationDetailsState, action) => {
        state.isLoading = false;
        state.item = action.payload;
      })
      .addCase(getConversationById.rejected, (state: ConversationDetailsState, action) => {
        const { error } = action;

        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      })
      .addCase(getConversationChannelTheme.pending, (state: ConversationDetailsState) => {
        state.channelTheme = null;
        state.isChannelThemeLoading = true;
      })
      .addCase(getConversationChannelTheme.fulfilled, (state: ConversationDetailsState, action) => {
        state.isChannelThemeLoading = false;
        state.channelTheme = action.payload.theme;
      })
      .addCase(getConversationChannelTheme.rejected, (state: ConversationDetailsState, action) => {
        state.isChannelThemeLoading = false;
        showApiErrors(action.error);
      })
      .addCase(approveSuggestedFaq.fulfilled, (state: ConversationDetailsState, action) => {
        state.isLoading = false;

        if (state.item) {
          state.item.suggestions = updateConversationSuggestions(state.item.suggestions, action.payload.suggestion);
        }
      })
      .addCase(rejectSuggestedFaq.fulfilled, (state: ConversationDetailsState, action) => {
        state.isLoading = false;

        if (state.item) {
          state.item.suggestions = updateConversationSuggestions(state.item.suggestions, action.payload);
        }
      });
  },
});

export const { resetConversationDetails } = conversationDetailsSlice.actions;
